import { Link } from "react-router-dom";
import { useAllCycles } from "@/hooks/useCycles";
import { useCompletedWeeks } from "@/hooks/useWeeks";
import { cycleDateRangeLabel, cycleLabel } from "@/lib/cycles";
import { weekRangeLabel } from "@/lib/days";

export function Arkiv() {
  const { weeks, loading } = useCompletedWeeks();
  const { cycles, loading: cyclesLoading } = useAllCycles();

  if (loading || cyclesLoading) return <p>Laster…</p>;

  // Newest first, as the weeks are.
  const archivedCycles = cycles.filter((c) => c.data.archived).reverse();

  return (
    <div data-screen-label="Arkiv">
      <h1 className="page-title">Arkiv</h1>

      <h2 className="arkiv-section-title">Uker</h2>
      {weeks.length === 0 ? (
        <p data-testid="arkiv-empty">Ingen fullførte uker.</p>
      ) : (
        <ul className="arkiv-list" data-testid="arkiv-list">
          {weeks.map((w) => (
            <li key={w.id}>
              <Link
                to={`/uke/${encodeURIComponent(w.id)}`}
                className="arkiv-item"
                data-testid={`arkiv-week-link-${w.id}`}
              >
                <span className="arkiv-item-title">
                  Uke {w.data.weekNumber} · {w.data.year}
                </span>
                <span className="arkiv-item-meta">
                  {weekRangeLabel(w.data.startDate)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}

      <h2 className="arkiv-section-title">Sykluser</h2>
      {archivedCycles.length === 0 ? (
        <p data-testid="arkiv-cycles-empty">Ingen arkiverte sykluser.</p>
      ) : (
        <ul className="arkiv-list" data-testid="arkiv-cycles-list">
          {archivedCycles.map((c) => (
            <li key={c.id}>
              <Link
                to={`/syklus/${encodeURIComponent(c.id)}`}
                className="arkiv-item"
                data-testid={`arkiv-cycle-link-${c.id}`}
              >
                <span className="arkiv-item-title">{cycleLabel(c.data)}</span>
                <span className="arkiv-item-meta">
                  {cycleDateRangeLabel(c.data)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
